import type { Currency } from "../../data/BaseEntity";

export function getExchangeRate(
  productCurrency: Currency | undefined,
  orderCurrency: Currency | undefined,
  orderCurrencyExchangeRate: number | undefined,
) {
  if (productCurrency === orderCurrency) {
    return 1;
  }
  if (!orderCurrencyExchangeRate || !orderCurrency) {
    return undefined;
  }
  if (productCurrency === "EUR" && orderCurrency === "PLN") {
    return orderCurrencyExchangeRate;
  }
  if (productCurrency === "PLN" && orderCurrency === "EUR") {
    return 1 / orderCurrencyExchangeRate;
  }
  return 1;
}
